import el from "@cypherpotato/el";
import { Badge, BadgeList, TagBadge } from "./badge";
import { Icon } from "./icon";
import page from "page";

export function IntegrationGrid(...children) {
    return el(".integration-grid", ...children);
}

export function IntegrationCard({ name, imageUrl, href, tags, onDelete, ...options }) {
    return el(".integration-card",
        el("img", { src: imageUrl, alt: name }),
        el("h3", name),
        tags?.length && BadgeList(tags.map(i => i && Badge(i))),
        onDelete && el("button.integration-card-delete", Icon("delete-bin-7-line"), {
            onClick(event) {
                event.stopPropagation();
                onDelete();
            }
        }),
        {
            onClick() {
                page(href);
            },
            ...options,
        }
    )
}